import { render } from "./dataasset.vue?vue&type=template&id=870b753a&scoped=true"
import script from "./dataasset.vue?vue&type=script&lang=js"
export * from "./dataasset.vue?vue&type=script&lang=js"

import "./dataasset.vue?vue&type=style&index=0&id=870b753a&lang=css"
import "./dataasset.vue?vue&type=style&index=1&id=870b753a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-870b753a"]])

export default __exports__